import { TableCell } from '@fluentui/react-components';
import { useStyles } from './styles.js';

export function ResizableTableCellBlank({ size }: { size: number | string }) {
    const styles = useStyles();

    return (
        <TableCell
            className={styles.cell}
            style={{
                width: size,
                minWidth: size,
                maxWidth: size,
            }}
        />
    );
}
